import React from 'react';
import { Icon } from '@/shared/icons';
import type { IconName } from '@/shared/icons';

/**
 * DrawerHeaderButton — botão de ação do header de drawer de detalhe
 * (`.drw-hbtn` do mockup, promovido a primitivo do DS em 2026-08-11 a partir
 * do drawer de Detalhes do Lead): 30px de altura, fs 12.5 semibold, borda
 * #e2e6ec; `prim` = roxo sólido para a ação principal.
 *
 * Só renderiza no desktop — no mobile as ações do header agrupam num kebab
 * único (`CardActionsMenu`). Ver UI_PATTERNS § Overlays item 7.
 */
export interface DrawerHeaderButtonProps {
  icon: IconName;
  label: string;
  /** Variante primária (roxo sólido) — ação principal do drawer */
  prim?: boolean;
  onClick: () => void;
  disabled?: boolean;
  'data-testid'?: string;
}

export const DrawerHeaderButton: React.FC<DrawerHeaderButtonProps> = ({
  icon,
  label,
  prim,
  onClick,
  disabled,
  'data-testid': dataTestId,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="inline-flex items-center gap-[5px] rounded-lg whitespace-nowrap font-semibold transition-colors disabled:opacity-50 disabled:pointer-events-none"
    style={{
      height: 30,
      padding: '0 9px',
      fontSize: '12.5px',
      ...(prim
        ? { backgroundColor: '#8b5cf6', border: '1px solid #8b5cf6', color: '#fff' }
        : { border: '1px solid #e2e6ec', color: '#475569', backgroundColor: 'transparent' }),
    }}
    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = prim ? '#7c3aed' : '#f8fafc'; }}
    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = prim ? '#8b5cf6' : 'transparent'; }}
    data-testid={dataTestId}
  >
    <Icon name={icon} size={14} />
    <span>{label}</span>
  </button>
);

DrawerHeaderButton.displayName = 'DrawerHeaderButton';
